export const roleGetters = {
    roleModuleList: state => state.role.roleModuleList,
    userRoleList: state => {
        const value = state.role.userRoleList;
        return value
    },
    companyRoleList: state => {
        const value = state.role.companyRoleList;
        console.log('companyRoleList',value)
        return value
    },
};